import useToastConfirmation from "../../../../components/common/toasts/useToastConfirmation";
import { useToast } from "../../../../components/common/toasts/ToastContext";
import ErrorToast from "../../../../components/common/toasts/ErrorToast";
import React from "react";
import { premiumRequest } from "../../../../services/Premium";
import useAsyncAction from "../../hooks/useAsyncAction";

/** Zapisuje aktualne pola do słownika bez zapisywania całego projektu świadectwa. */
export default function DictionaryRecordSave({
  token,
  organizationId,
  definition,
  value,
  disabled,
  label,
}) {
  const { notify } = useToast();
  const { confirm } = useToastConfirmation(
    `${token}:${organizationId}:${definition.kind}`,
  );
  const { busy, error, run } = useAsyncAction(
    `${token}:${organizationId}:${definition.kind}`,
  );
  const save = () =>
    run(async (isActive) => {
      const data = {
        kind: definition.kind,
        value: Object.fromEntries(
          definition.fields.map((field) => [field.key, value[field.key] || ""]),
        ),
      };
      const send = (payload) =>
        premiumRequest(
          token,
          `/organizations/${organizationId}/dictionaries/records`,
          { method: "POST", data: payload },
        );
      let result;
      try {
        result = await send(data);
      } catch (failure) {
        const conflict =
          failure.response?.status === 409 && failure.response.data;
        if (!conflict?.entry) throw failure;
        if (!isActive()) return;
        const existing = definition.fields
          .map(
            (field) =>
              `${field.label}: ${conflict.entry.value[field.key] || ""}`,
          )
          .join("\n");
        if (
          !(await confirm(
            `W słowniku istnieje wpis „${conflict.entry.key}”:\n\n${existing}\n\nZastąpić go aktualnymi danymi z formularza?`,
            { acceptLabel: "Zastąp dane" },
          )) ||
          !isActive()
        )
          return;
        result = await send({ ...data, expectedValue: conflict.entry.value });
      }
      if (isActive()) notify(result.message || "Zapisano wpis w słowniku.");
    });
  return (
    <div className="premium-record-save">
      <button
        type="button"
        className="btn btn-outline-primary btn-sm"
        disabled={disabled || busy}
        onClick={save}
      >
        <i className="bi bi-bookmark-plus" aria-hidden="true" />{" "}
        {busy ? "Zapisywanie…" : label}
      </button>
      <ErrorToast message={error} />
    </div>
  );
}
